import { useState } from 'react';

export type Theme = 'light' | 'dark';
export function readEmbedContext(search: string) {
  const query = new URLSearchParams(search);
  const embedded = query.get('osEmbed') === '1';
  const theme = query.get('osTheme');
  return { embedded, theme: embedded && (theme === 'light' || theme === 'dark') ? theme : null };
}
// Keep the entry context through internal SPA navigation; hints are presentation only.
export const embedContext = readEmbedContext(typeof location === 'undefined' ? '' : location.search);
const key = 'hsp_proposals_theme';
export function initTheme() {
  let stored: string | null = null;
  try { stored = localStorage.getItem(key); } catch { /* Storage may be unavailable in an iframe. */ }
  document.documentElement.dataset.theme = embedContext.theme ?? (stored === 'dark' ? 'dark' : 'light');
  document.documentElement.dataset.embedded = String(embedContext.embedded);
}
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light');
  function toggle() {
    const next = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    setTheme(next);
    if (!embedContext.embedded) try { localStorage.setItem(key, next); } catch { /* Optional preference. */ }
  }
  return { theme, toggle };
}
